import styled from 'styled-components';
import theme from '../theme';

const ContenedorBotonesLista = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap:no-wrap;
    justify-content: center;
`;
 
const BotonEditar = styled.button`
    border: none;
    background: #007238;
    width: 1.5rem; /* 40px */
    display: inline-block;
    height: 1.5rem; /* 40px */
    line-height: 2.5rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    border-radius: 0.31rem; /* 5px */
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 .1rem;
 
    &:hover {
        opacity: .8;
    }

    &:hover > svg{
        fill: white;
    }
 
    svg {
        width: .8rem; /* 18px */
        fill: #fff;
    }
`;

const BotonEliminar = styled.button`   
    background: red;
    border: none;
    width: 1.5rem; /* 40px */
    display: inline-block;
    height: 1.5rem; /* 40px */
    line-height: 2.5rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    border-radius: 0.31rem; /* 5px */
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 .1rem;
 
    &:hover {
        opacity: .8;
    }

    &:hover > svg{
        fill: white;
    }
 
    svg {
        width: .8rem; /* 18px */
        fill: #fff;
    }
`;


const BotonAprobar = styled.button`   
    background: #007238;
    border: none;
    width: 1.7rem; /* 40px */
    display: inline-block;
    height: 1.7rem; /* 40px */
    line-height: 2.5rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    border-radius: 0.31rem 0 0 0.31rem; /* 5px */
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
 
    &:hover {
        opacity: .8;
    }

    &:hover > svg{
        fill: #fff;
    }
 
    svg {
        width: 1rem;
        fill: #fff;
    }
`;

const BotonRechazar = styled.button`   
    background: #fbd000;
    border: none;
    width: 1.7rem; /* 40px */
    display: inline-block;
    height: 1.7rem; /* 40px */
    line-height: 2.5rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
 
    &:hover {
        opacity: .8;
    }

    &:hover > svg{
        fill: #000;
    }
 
    svg {
        width: 1rem; /* 18px */
        fill: #000;
    }
`;

const BotonEliminarTrash = styled.button`   
    background: red;
    border: none;
    width: 1.7rem; /* 40px */
    display: inline-block;
    height: 1.7rem; /* 40px */
    line-height: 2.5rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    border-radius: 0 0.31rem 0.31rem 0; /* 5px */
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
 
    &:hover {
        opacity: .8;
    }

    &:hover > svg{
        fill: white;
    }
 
    svg {
        width: .8rem; /* 18px */
        fill: #fff;
    }
`;

const BotonCheck = styled.button`
    background: #007238;   
    border: none;
    width: 1.5rem; /* 40px */
    display: inline-block;
    height: 1.5rem; /* 40px */
    line-height: 2.5rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    border-radius: 0.31rem; /* 5px */
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 .1rem;
 
    &:hover {
        opacity: .8;
    }

    &:hover > svg{
        fill: white;
    }
 
    svg {
        width: .8rem; /* 18px */
        fill: #fff;
    }
`;

const Buscador = styled.div`
    width: 90%;
    display: flex;
    justify-content: right;
    margin-bottom: 2rem;
`;

const ContenedorBuscador = styled.div`
    width: 50%;
    position: relative;
`;

const InputBuscador = styled.input`
    font-size: 1rem;
    width: 100%;
    height: 100%;
    display: block;
    text-align: left;
    padding: .5rem 2rem .5rem 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 1rem;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.2);
 
    @media(max-width: 60rem){ /* 950px */
        font-size: .9rem; /* 24px */
    }
`;

export {
    ContenedorBotonesLista,
    BotonEditar,
    BotonEliminar,
    BotonEliminarTrash,
    BotonCheck,
    BotonAprobar,
    BotonRechazar,
    Buscador,
    ContenedorBuscador,
    InputBuscador
};